import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import modules from './modules'
import VuexPersist from 'vuex-persist'
import buildPrivatePub from '@/plugins/privatePub'
import sharedMutations from '../plugins/sharedMutations/vuexSharedMutations'

// import faye from 'faye'
const vuexPersistModule = new VuexPersist({
  key: 'mp.vx',
  storage: window.localStorage,
  reducer: (state) => ({
    auth : state.auth,
    ui : {
      layout: state.ui.layout,
      chat: state.ui.chat,
      leftmenu: state.ui.leftmenu,
      loader: state.ui.loader,
      newUpdateAvailable: state.ui.newUpdateAvailable,
      iframe: state.ui.iframe,
      notifications: state.ui.notifications,
      campaign_row:state.ui.campaign_row,
      folder: state.ui.folder,
      gridView: state.ui.gridView,
      previousRoute: state.ui.previousRoute
    }
  })
})

const vuexPersistState = new VuexPersist({
  key: 'mp.vxl',
  storage: window.localStorage,
  reducer: (state) => ({
    campaign: {
      id: state.campaign.id,
      type: state.campaign.type,
      privileges: state.campaign.privileges,
      scheduleWithItems: state.campaign.scheduleWithItems
    },
    segments:{
      built_with_ai: false
    },
    reports : {
      selectedReportType : state.reports.selectedReportType
    },
    acquisition:{
      templateFormId: state.acquisition.templateFormId
    },
    journey:{
      journeyTitle: state.journey.journeyTitle,
      template: state.journey.template,
      returnFromStore: state.journey.returnFromStore,
      workflow: state.journey.workflow
    },
    landingPages: {
      jsonPart: state.landingPages.jsonPart,
      editorType:state.landingPages.editorType
    }
  }),
})

// mutations which needs to be shared between tabs
const dataToBeShared = ['sharedEvent','auth/userdata','auth/iframe.document','auth/token','auth/account.list']

const sharedTabsData = sharedMutations({ predicate: dataToBeShared })

const plugins = [vuexPersistModule.plugin, vuexPersistState.plugin, sharedTabsData]

Vue.use(Vuex)
// Vue.use(faye)

export default new Vuex.Store({
  state: {
    logoutIframeURL: '',
    folderId: null,
    parentFolderId:null,
    newEmailCampaignContent: {},
    campaign_id: null,
    gridView: null,
    sharedEvent:'',
    reloadTab:true
  },
  getters: {
    allData: state => state.data,
    accountId: (state) => {
      if (!state.accountId) {
        const accountId = localStorage.getItem('accountId')
        state.accountId = accountId
      }
      return state.accountId
    },
  },
  actions: {
    updateCampaign ({ commit }, payload) {
      commit('update_campaign', payload)
    },
    fetchData ({ commit }, payload) {
      commit('setData', payload)
    },
    async login ({ commit }, credentials) {
      const { data } = await axios
        .post('//localhost:3500/login', credentials)
      commit('SET_USER', data)
    },
    logout ({ commit }) {
      commit('CLEAR_USER')
    },
    toggle_spinner ({ commit }, value) {
      commit('setSpinner', value)
    },
  },
  mutations: {
    setFolderId(state, payload) {
      state.folderId = payload
    },
    setParentFolderId(state, payload){
      state.parentFolderId = payload
    },
    update_campaign: (state, obj) => {
      state.test = obj
      },
    SET_LAYOUT (state, payload) {
      state.layout = payload
    },
    SET_USER (state, userData) {
      state.userData = userData
      localStorage.setItem('userData', JSON.stringify(userData))
      axios.defaults.headers.common.Authorization = `Bearer ${
        userData.token
      }`
    },
    CLEAR_USER () {
      localStorage.clear()
      buildPrivatePub.resetConnection()
      localStorage.removeItem('userData')
      location.reload()
    },
    setData: function (state, data) { state.data = data },
    setSpinner: function (state, value) { state.loading_spinner = value },
    accountId: (state, value) => { state.accountId = value },
    sharedEvent:(state,value)=>state.sharedEvent=value,
    reloadTab:(state,value)=>state.reloadTab=value
  },
  modules: modules,
  plugins: plugins,
})
